var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Background"},[_c('h2',{staticClass:"Title"},[_vm._v("VOD 통계")]),_c('VodStatistics')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }